import actions from './actionTypes';
const defaultState = false;

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.LOG_IN:
    case actions.LOG_OUT:
    case actions.READ_TOKEN:
      return true;
    case actions.LOGIN_ERROR:
    case actions.LOGGED_IN:
    case actions.LOGOUT_ERROR:
    case actions.LOGGED_OUT:
    case actions.READ_TOKEN_ERROR:
      return false;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/loading.js